import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import ToSText from "../content/ToS.js";
import "../styles/markdown.css";

import { Link, useNavigate } from "react-router-dom";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";

function ToS() {
  return (
    <div>
      <div className="container">
        <div className="markdown-container">
          <ReactMarkdown>{ToSText}</ReactMarkdown>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ToS;
